// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".src-routes-App-components-InfoBox-infobox__infoBox--3SMmV{color:#d8dadc;background:#121213;margin:16px;padding:16px;line-height:1.3em;font-size:14px;max-width:480px;align-self:center}.src-routes-App-components-InfoBox-infobox__infoBox--3SMmV i{color:#757678}\n", ""]);
// Exports
exports.locals = {
	"infoBox": "src-routes-App-components-InfoBox-infobox__infoBox--3SMmV"
};
module.exports = exports;
